import HomeContainer from "../../HomeContainer";

const Home = () => {
  return(
	// <div className="w-screen h-screen overflow-x-hidden overflow-y-hidden">
	<div className="w-screen h-screen overflow-y-hidden">
		<HomeContainer />
	</div>
  ) 
}

export default Home;